import * as api from './adapter';
import { apiRequest } from './adapter';
import selectOptionsApi from './selectOptions';
import {update} from "./adapter";

const defaultPaging = {
  page: { size: 999 },
}

// CREW-1299 — a vessel's own wage matrix. Plain JSON, `:id` is the VESSEL's
// id. Headers go in `apiRequest`'s third argument, never inside the options:
// the two are merged shallowly and an `options.headers` would drop the auth
// headers (see `wageComponents.js`).
const VESSEL_MATRICES_URL = '/api/crew_wage/vessel_matrices';
const JSON_HEADERS = { 'Content-Type': 'application/json' };
export default {


  getTypes: () => selectOptionsApi.index({ type: 'crew_wage_scale_types' }),

  getScales: (override) => api.read('crew_wage/scales', {
    ...override,
    query: {
      ...defaultPaging,
      ...override.query,
    }
  }),

  updateScale: (id, attributes) => api.update({ id, type: 'scales', controller: 'crew_wage/scales', attributes: attributes }),

  getBonuses: (override) => api.read('crew_wage/bonuses', {
    ...override,
    query: {
      ...defaultPaging,
      ...override.query,
    }
  }),

  updateBonus: (id, attributes) => api.update({ id, type: 'bonuses', controller: 'crew_wage/bonuses', attributes: attributes }),

  // CREW-1184 — the wage agreed for one timeplan slot. One row per slot,
  // so the filtered index is how you fetch "the" wage; an empty `data`
  // means the slot has never had one.
  getSlotWage: ({ timePlanId }) => api.read('crew_wage/slot_wages', {
    query: { filter: { time_plan_id: timePlanId } },
  }),

  // Posting nothing but `time_plan_id` is deliberate: the backend seeds
  // every money line from the owner's rate card
  // (`CrewWage::SlotWage::PrefillFromScale`). Sending zeros here would be
  // read as "the coordinator agreed zero" and suppress the prefill.
  createSlotWage: (attributes) => api.create({
    type: 'slot_wages', controller: 'crew_wage/slot_wages', attributes,
  }),

  updateSlotWage: (id, attributes) => api.update({
    id, type: 'slot_wages', controller: 'crew_wage/slot_wages', attributes,
  }),

  // CREW-1101 — write the owner's CURRENT rate card back onto this slot,
  // frozen or not. A member POST with no body on purpose: what it writes is
  // read from the rate card server-side, not sent from here.
  //
  // No `headers` in the options object — `apiRequest` merges options over the
  // defaults shallowly, so passing one would drop the auth headers with it.
  resyncSlotWage: (id) => apiRequest(
    `/api/crew_wage/slot_wages/${id}/resync_from_matrix`,
    { method: 'POST' },
  ),

  // → { data: { vessel_id, owner_id, owner_name, overridden } }
  getVesselMatrix: (vesselId) => api.read(`crew_wage/vessel_matrices/${vesselId}`),

  // A copy of the owner's matrix becomes the vessel's own. Answers the same
  // shape as `getVesselMatrix`.
  overrideVesselMatrix: (vesselId) => apiRequest(
    VESSEL_MATRICES_URL,
    { method: 'POST', body: JSON.stringify({ vessel_id: vesselId }) },
    JSON_HEADERS,
  ),

  // The vessel's own cards are deleted; it is paid from the owner's again.
  resetVesselMatrix: (vesselId) => apiRequest(
    `${VESSEL_MATRICES_URL}/${vesselId}`,
    { method: 'DELETE' },
    JSON_HEADERS,
  ),

  // Same shape as `owner.getScaleNationalities`, for the vessel's own matrix.
  getVesselNationalities: (vesselId) => api.read(`crew_wage/vessel_matrices/${vesselId}/nationalities`),

  addVesselNationality: (vesselId, nationalityId) => apiRequest(
    `${VESSEL_MATRICES_URL}/${vesselId}/nationalities`,
    { method: 'POST', body: JSON.stringify({ nationality_id: nationalityId }) },
    JSON_HEADERS,
  ),
}
